import React, { useState } from "react";
import "./SupplierContent.scss";
import SupplierCreateModal from "./SupplierCreateModal";
import SupplierDetailsModal from "./SupplierDetailsModal";
import SupplierTable from "./SupplierTable";
import { InventoryService } from "../../../../network/InventoryService";
import { useNotification } from "../../../../../Notifications/NotificationProvider";

const SupplierContent = ({
  showSupplierCreateModal,
  setShowSupplierCreateModal,
  searchText,
  onCreateSupplier,
}) => {
  const [supplierListKey, setSupplierListKey] = useState(0);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const dispatchNotification = useNotification();

  const handleSupplierCreated = () => {
    setSupplierListKey((prev) => prev + 1);
    if (onCreateSupplier) {
      onCreateSupplier();
    }
  };

  const handleSupplierSelect = (supplier) => {
    setSelectedSupplier(supplier);
    setShowDetailsModal(true);
  };

  const handleDeactivateSupplier = async (supplierId) => {
    try {
      const response = await InventoryService.deactivateSupplier(supplierId);

      if (response.is_error === 0) {
        dispatchNotification({
          type: "SUCCESS",
          message: "Supplier deactivated successfully!",
        });

        setSupplierListKey((prev) => prev + 1);
      } else {
        throw new Error(response.message || "Failed to deactivate supplier");
      }
    } catch (error) {
      console.error("Error deactivating supplier:", error);

      let errorMessage = "Failed to deactivate supplier. Please try again.";

      if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      }

      dispatchNotification({
        type: "ERROR",
        message: errorMessage,
      });

      throw error;
    }
  };

  return (
    <div className="inventory-content-container">
      <SupplierTable
        key={supplierListKey}
        searchText={searchText}
        setShowSupplierCreateModal={setShowSupplierCreateModal}
        onSupplierSelect={handleSupplierSelect}
      />

      <SupplierCreateModal
        showSupplierCreateModal={showSupplierCreateModal}
        setShowSupplierCreateModal={setShowSupplierCreateModal}
        onSupplierCreated={handleSupplierCreated}
      />

      {showDetailsModal && selectedSupplier && (
        <SupplierDetailsModal
          onClose={() => setShowDetailsModal(false)}
          supplier={selectedSupplier}
          onDeactivate={handleDeactivateSupplier}
        />
      )}
    </div>
  );
};

export default SupplierContent;
